function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState } from "react";
import { AutoComplete, Button, Input, Spin, message } from "antd";
import { PinMapFill, GeoAltFill } from "react-bootstrap-icons";
import axios from "axios";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AddressInput = function AddressInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    onLocationSelect = _ref.onLocationSelect;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    locating = _useState6[0],
    setLocating = _useState6[1];
  var searchTimeout = useRef(null);
  /**
   * Recherche d'adresse
   */
  var searchAddress = function searchAddress(searchText) {
    if (!searchText || searchText.length < 3) {
      setOptions([]);
      return;
    }
    clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setLoading(true);
            _context.n = 1;
            return axios.get("https://nominatim.openstreetmap.org/search", {
              params: {
                q: searchText,
                format: "json",
                addressdetails: 1,
                limit: 5,
                countrycodes: "gn"
              }
            });
          case 1:
            response = _context.v;
            setOptions(response.data.map(function (item) {
              return {
                value: item.display_name,
                label: /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("div", {
                    children: item.display_name
                  }), /*#__PURE__*/_jsxs("small", {
                    style: {
                      color: "#999"
                    },
                    children: ["\uD83D\uDCCD ", item.lat, ", ", item.lon]
                  })]
                }),
                latitude: parseFloat(item.lat),
                longitude: parseFloat(item.lon),
                address: item.address
              };
            }));
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error(_t);
            setOptions([]);
          case 3:
            _context.p = 3;
            setLoading(false);
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    })), 500);
  };
  /**
   * Sélection d'une adresse
   */
  var handleSelect = function handleSelect(value, option) {
    onChange === null || onChange === void 0 || onChange(value);
    onLocationSelect === null || onLocationSelect === void 0 || onLocationSelect({
      address: value,
      latitude: option.latitude,
      longitude: option.longitude,
      details: option.address
    });
  };
  /**
   * Récupération de la position actuelle
   */
  var getCurrentLocation = function getCurrentLocation() {
    if (!navigator.geolocation) {
      message.error("La géolocalisation n'est pas supportée par votre navigateur.");
      return;
    }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(position) {
        var latitude, longitude, response, address, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              latitude = position.coords.latitude;
              longitude = position.coords.longitude;
              _context2.p = 1;
              _context2.n = 2;
              return axios.get("https://nominatim.openstreetmap.org/reverse", {
                params: {
                  lat: latitude,
                  lon: longitude,
                  format: "json",
                  addressdetails: 1
                }
              });
            case 2:
              response = _context2.v;
              address = response.data.display_name; // Mettre l'adresse dans le Input
              onChange === null || onChange === void 0 || onChange(address);
              // Retourner toutes les informations
              onLocationSelect === null || onLocationSelect === void 0 || onLocationSelect({
                address: address,
                latitude: latitude,
                longitude: longitude,
                details: response.data.address
              });
              //location fetched
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error(_t2);
              message.error("Impossible de récupérer l'adresse de votre position.");
            case 4:
              _context2.p = 4;
              setLocating(false);
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), function (error) {
      setLocating(false);
      switch (error.code) {
        case error.PERMISSION_DENIED:
          message.error("Vous avez refusé l'accès à votre position.");
          break;
        case error.POSITION_UNAVAILABLE:
          message.error("Votre positions n'est pas disponible.");
          break;
        case error.TIMEOUT:
          message.error("La récupération de votre position a expiré.");
          break;
        default:
          message.error("Impossible de récupérer votre position.");
      }
    }, {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0
    });
  };
  return /*#__PURE__*/_jsx(AutoComplete, {
    value: value,
    options: options,
    onSearch: searchAddress,
    onSelect: handleSelect,
    onChange: onChange,
    style: {
      width: "100%"
    },
    children: /*#__PURE__*/_jsx(Input, {
      size: "large",
      placeholder: "Adresse de livraison ...",
      prefix: loading ? /*#__PURE__*/_jsx(Spin, {
        size: "small"
      }) : /*#__PURE__*/_jsx(GeoAltFill, {
        color: "#00398F"
      }),
      suffix: /*#__PURE__*/_jsx(Button, {
        type: "text",
        icon: locating ? /*#__PURE__*/_jsx(Spin, {
          size: "small"
        }) : /*#__PURE__*/_jsx(PinMapFill, {
          color: "#FB9936"
        }),
        loading: locating,
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          getCurrentLocation();
        },
        title: "Utiliser ma position actuelle",
        children: "Ma position"
      })
    })
  });
};
export default AddressInput;